<template>
    <div>
        <b-card title="" border-variant="primary">
            <form-base-document-atex
                :documents-state-data="documents_maintenance_atex"
                :documents-columns="columns"
                :documents-route="documents_by_route_maintenance_atex"
                :context="'document-atex'"
                :create-permission="can('create_gei_children_maintenance_atex')"
                :delete-permission="can('delete_gei_children_maintenance_atex')"
            />
        </b-card>
    </div>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import {mapState} from "vuex"
import formBaseDocumentAtex
    from "@/views/gei/children_installations/form/tabMaintenance/components/base/formBaseAtex"

import {mapFields} from "vuex-map-fields"

export default {
    name: "FormContractProviderDocuments",
    components: {
        BCard,
        formBaseDocumentAtex
    },
    data() {
        return {
            columns: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'effective_date', label: 'Fecha Realización', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],
        }
    },
    computed: {
        ...mapState('childrenInstallation', []),
        ...mapState('childrenInstallationDocuments', []),
        ...mapFields({
            documents_maintenance_atex: 'childrenInstallationDocuments.documents_maintenance_atex',
            documents_by_route_maintenance_atex: 'childrenInstallationDocuments.documents_by_route_maintenance_atex',
            child_installation: 'childrenInstallation.child_installation',
        }),
    },
    mounted() {
       this.context = 'document-atex'
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
    }

}
</script>